import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import notificationApi from '@/core/notifications/api/notification-api';
import { Loading, SectionHeader } from '@/shared/components/export';

export default function ProfileSection() {
  const [displayName, setDisplayName] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    notificationApi
      .getProfile()
      .then(profile => setDisplayName(profile.displayName ?? ''))
      // profile is created lazily server-side; a 404 just means it does not exist yet
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const handleSave = async () => {
    setSaving(true);
    try {
      await notificationApi.updateProfile(displayName.trim());
      toast.success('Profile updated');
    } catch (e) {
      toast.error('Could not update the profile');
    } finally {
      setSaving(false);
    }
  };

  if (loading)
    return (
      <div className="p-4">
        <Loading type="bar" />
      </div>
    );

  return (
    <div>
      <SectionHeader title="Profile" />

      <div className={`px-3 pb-2 mutedText`} style={{ fontSize: 14 }}>
        Your display name, shown in notification messages sent to you.
      </div>

      <div className="px-3 pb-3">
        <div style={{ maxWidth: 360 }}>
          <label className="form-label">Display name</label>
          <input
            className="form-control form-control-sm"
            value={displayName}
            onChange={event => setDisplayName(event.target.value)}
          />
          <button
            className="btn btn-link btn-sm p-0 fw-bold text-decoration-none mt-2"
            disabled={saving || !displayName.trim()}
            onClick={handleSave}
          >
            {saving ? 'Saving…' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
}
